export const OHL = {
    name: 'DV 458 RP ĐERDAP 1 - HE ĐERDAP 1, blok 2',
    voltage: '400',
    regionCode: 'BR',
    stanice: [{name: 'ĐERDAP 1', position: {lat: 44.6652, lng: 22.5243}}],
    stubovi: [
        { index: 1, name: 'P-brana', lat: 44.6689 , lng: 22.5273, portal: true  },
        { index: 2, name: 'P-prevod', lat: 44.6674 , lng: 22.5273 },
        { index: 3, name: '1', lat: 44.666 , lng: 22.5256 },
        { index: 4, name: 'P-RP', lat: 44.6655 , lng: 22.5251, portal: true  }
    ],
    rasponi: [
        { name: 'P-brana - P-prevod', position: [{ lat: 44.6689 , lng: 22.5273 }, { lat: 44.6674 , lng: 22.5273 }] },
        { name: 'P-prevod - 1', position: [{ lat: 44.6674 , lng: 22.5273 }, { lat: 44.666 , lng: 22.5256 }] },
        { name: '1 - P-RP', position: [{ lat: 44.666 , lng: 22.5256 }, { lat: 44.6655 , lng: 22.5251 }] }
    ]
}
